import React from 'react';
import {useSelector} from 'react-redux';
import classNames from 'classnames';
import {CoreDoms, ViewMode, EditorExperienceType} from '@taopix/taopix-core';
import {PageInterface, ProductLayout} from '@taopix/taopix-core/dist/types/types';
import {PageListSelector, PagesSelector} from '../../../Selectors';
import Page from '../../Page/Page';
import {useUiState} from '../../Context/UserInterface/UserInterfaceContext';
import {useTaopix} from '../../Context/TaopixContext';
import {greetingCard3dViewType} from '../../Editors/GreetingCard/Project/Project';
import './GreetingCardView.scss';

export interface GreetingCardViewProps {
  layout: ProductLayout;
  current3DView: greetingCard3dViewType;
  setCurrentView: React.Dispatch<React.SetStateAction<greetingCard3dViewType>>;
}

const GreetingCardView = ({layout, current3DView, setCurrentView}: GreetingCardViewProps) => {
  const ui = useUiState();
  const app = useTaopix();
  const pageNumberList = useSelector(PageListSelector);

  // get the pages from the store
  const pages = useSelector(PagesSelector);

  const tpxCoreAttrs = {
    [CoreDoms.ProjectPagesAttr]: 'true',
  };

  const pagesContainerClasses = classNames(
    'tpx-greetingCardPageList',
    // Give the mobile project area some height to enable scrolling on the parent
    // (its children are absolutely positioned so it would normally be zero height)
    'sm:h-full',
    'sm:focusMode:mt-lg',
    'sm:focusMode:mb-[80px]'
  );

  const listItemClasses = classNames('tpx-greetingCardListItem', 'border', 'border-[#efefef]');

  const clickPage = (requestedPageIndex: Number) => {
    // When clicking the inside left, and current is the inside right, switch to inside left
    if (requestedPageIndex === 1 && current3DView === 'inside-right') {
      setCurrentView('inside-left');
      app.core.get('abilities').setPage(pageNumberList[1]).then();
    }
    // When clicking the inside left, and current is the inside right, switch to inside left
    if (requestedPageIndex === 2 && current3DView === 'inside-left') {
      setCurrentView('inside-right');
      app.core.get('abilities').setPage(pageNumberList[2]).then();
    }
  };

  return (
    <ul {...tpxCoreAttrs} className={pagesContainerClasses}>
      {pages.map((page: PageInterface, pageIndex) => {
        const selectedPageClass = ui.state.pageNumber === page.pagenumber ? 'tpx-current-page' : '';
        return (
          <li
            data-id={page.pagenumber}
            className={classNames(listItemClasses, selectedPageClass)}
            key={`listview-${page.ref}`}
            onClick={() => clickPage(pageIndex)}
          >
            <Page
              page={page}
              layout={layout}
              editorType={EditorExperienceType.Card}
              viewMode={ViewMode.List}
              showErrors={true}
              showEmptyBoxes={true}
              showBleed={{outside: false, inside: false}}
              showPageHighlights={false}
              uiLayoutMode={'basic'}
            />
          </li>
        );
      })}
    </ul>
  );
};

export default GreetingCardView;
